import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'
import './Blog.css';

const Blog = (props) => {
    // const [data, setData] = useState({
    //     business:[],
    //     guide:[],
    //     technology:[],
    //     sports:[],
    //     gaming:[],
    //     entertainment:[],
    //     lifestyle:[],
    //     art:[],
    //     announcement:[],
    //     guestPost:[]
    // });
    const colorString = Object.values(props).toString();
    const [nft, setNft] = useState([]);
    const [business, setBusiness] = useState([]);
    const [guide, setGuide] = useState([]);
    const [technology, setTechnology] = useState([]);
    const [sports, setSports] = useState([]);
    const [gaming, setGaming] = useState([]);
    const [entertainment, setEntertainment] = useState([]);
    const [lifestyle, setLifestyle] = useState([]);
    const [art, setArt] = useState([]);
    const [announcement, setAnnouncement] = useState([]);
    const [guestPost, setGuestPost] = useState([]);
    useEffect(() => {
        window.scrollTo(0, 0)
        axios.get('https://appi.colexion.io/api/Blog/business').then(resp => {
            setBusiness(resp.data);
        });
        axios.get('https://appi.colexion.io/api/Blog/nft').then(resp => {
            setNft(resp.data);
        });
        axios.get('https://appi.colexion.io/api/Blog/guide').then(resp => {
            setGuide(resp.data);
        });
        axios.get('https://appi.colexion.io/api/Blog/technology').then(resp => {
            setTechnology(resp.data);
        });
        axios.get('https://appi.colexion.io/api/Blog/sports').then(resp => {
            setSports(resp.data);
        });
        axios.get('https://appi.colexion.io/api/Blog/gaming').then(resp => {
            setGaming(resp.data);
        });
        axios.get('https://appi.colexion.io/api/Blog/entertainment').then(resp => {
            setEntertainment(resp.data);
        });
        axios.get('https://appi.colexion.io/api/Blog/lifestyle').then(resp => {
            setLifestyle(resp.data);
        });
        axios.get('https://appi.colexion.io/api/Blog/art').then(resp => {
            setArt(resp.data);
        });
        axios.get('https://appi.colexion.io/api/Blog/announcement').then(resp => {
            setAnnouncement(resp.data);
        });
        axios.get('https://appi.colexion.io/api/Blog/guest-post').then(resp => {
            setGuestPost(resp.data);
        });
        setTimeout(()=>{
            window.scrollTo(0, 0)
        }, 100)
    }, [])
    console.log(guide)
    return(
        <div className={colorString === 'true'?`blog_page pb-5 dark`: `blog_page pb-5 whiteTheme`}>
            <div className="container">
                {business.slice(0, 1).map(blogData=>(
                    <div className="row blog-section blog-right-col" key={blogData._id}>
                        <div className="col-md-6">
                            <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                        </div>
                        <div className="col-md-6">
                            <p className="blog-Wallets">{blogData.category}</p>
                            <p className="blogHeading">{blogData.title}</p>
                            <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                            <Link className="Read-Article" to={`/blog-detail/${blogData._id}`}>
                                <span>Read Article <img className="arrow-img" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'} alt=""/></span>
                            </Link>
                        </div>
                    </div>
                ))}
               

                <div className="">
                    <div className="row blog-grid blog-right-col">
                    {business.map((blogData, index)=>(
                        <>
                        {
                            index !== 0
                            ?
                            <div className="col-md-4 mb-5" key={blogData._id}>
                                {console.log(index)}
                                <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                                <p className="grid-Wallets">{blogData.category}</p>
                                <p className="grid-card-head">{blogData.title}</p>
                                <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                                <Link to={`/blog-detail/${blogData._id}`} className="grid-Read-Article">Read Article <img className="grid-arrow-img" alt="" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'}/></Link>
                            </div>
                        :
                        null
                        }
                        </>
                    ))}
                        
                       
                    </div>
                    
                </div>

            </div>

            <div className="container">
                {nft.slice(0, 1).map(blogData=>(
                    <div className="row blog-section blog-right-col" key={blogData._id}>
                        <div className="col-md-6">
                            <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                        </div>
                        <div className="col-md-6">
                            <p className="blog-Wallets">{blogData.category}</p>
                            <p className="blogHeading">{blogData.title}</p>
                            <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                            <Link className="Read-Article" to={`/blog-detail/${blogData._id}`}>
                                <span>Read Article <img className="arrow-img" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'} alt=""/></span>
                            </Link>
                        </div>
                    </div>
                ))}
               

                <div className="">
                    <div className="row blog-grid blog-right-col">
                    {nft.map((blogData, index)=>(
                        <>
                        {
                            index !== 0
                            ?
                            <div className="col-md-4 mb-5" key={blogData._id}>
                                {console.log(index)}
                                <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                                <p className="grid-Wallets">{blogData.category}</p>
                                <p className="grid-card-head">{blogData.title}</p>
                                <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                                <Link to={`/blog-detail/${blogData._id}`} className="grid-Read-Article">Read Article <img className="grid-arrow-img" alt="" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'}/></Link>
                            </div>
                        :
                        null
                        }
                        </>
                    ))}
                        
                       
                    </div>
                    
                </div>

            </div>
            <div className="container">
                {guide.slice(0, 1).map(blogData=>(
                    <div className="row blog-section blog-right-col" key={blogData._id}>
                        <div className="col-md-6">
                            <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                        </div>
                        <div className="col-md-6">
                            <p className="blog-Wallets">{blogData.category}</p>
                            <p className="blogHeading">{blogData.title}</p>
                            <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                            <Link className="Read-Article" to={`/blog-detail/${blogData._id}`}>
                                <span>Read Article <img className="arrow-img" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'} alt=""/></span>
                            </Link>
                        </div>
                    </div>
                ))}
               

                <div className="">
                    <div className="row blog-grid blog-right-col">
                    {guide.map((blogData, index)=>(
                        <>
                        {
                            index !== 0
                            ?
                            <div className="col-md-4 mb-5" key={blogData._id}>
                                {console.log(index)}
                                <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                                <p className="grid-Wallets">{blogData.category}</p>
                                <p className="grid-card-head">{blogData.title}</p>
                                <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                                <Link to={`/blog-detail/${blogData._id}`} className="grid-Read-Article">Read Article <img className="grid-arrow-img" alt="" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'}/></Link>
                            </div>
                        :
                        null
                        }
                        </>
                    ))}
                        
                       
                    </div>
                    
                </div>

            </div>

            <div className="container">
                {technology.slice(0, 1).map(blogData=>(
                    <div className="row blog-section blog-right-col" key={blogData._id}>
                        <div className="col-md-6">
                            <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                        </div>
                        <div className="col-md-6">
                            <p className="blog-Wallets">{blogData.category}</p>
                            <p className="blogHeading">{blogData.title}</p>
                            <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                            <Link className="Read-Article" to={`/blog-detail/${blogData._id}`}>
                                <span>Read Article <img className="arrow-img" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'} alt=""/></span>
                            </Link>
                        </div>
                    </div>
                ))}
               

                <div className="">
                    <div className="row blog-grid blog-right-col">
                    {technology.map((blogData, index)=>(
                        <>
                        {
                            index !== 0
                            ?
                            <div className="col-md-4 mb-5" key={blogData._id}>
                                {console.log(index)}
                                <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                                <p className="grid-Wallets">{blogData.category}</p>
                                <p className="grid-card-head">{blogData.title}</p>
                                <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                                <Link to={`/blog-detail/${blogData._id}`} className="grid-Read-Article">Read Article <img className="grid-arrow-img" alt="" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'}/></Link>
                            </div>
                        :
                        null
                        }
                        </>
                    ))}
                        
                       
                    </div>
                    
                </div>

            </div>

            <div className="container">
                {sports.slice(0, 1).map(blogData=>(
                    <div className="row blog-section blog-right-col" key={blogData._id}>
                        <div className="col-md-6">
                            <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                        </div>
                        <div className="col-md-6">
                            <p className="blog-Wallets">{blogData.category}</p>
                            <p className="blogHeading">{blogData.title}</p>
                            <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                            <Link className="Read-Article" to={`/blog-detail/${blogData._id}`}>
                                <span>Read Article <img className="arrow-img" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'} alt=""/></span>
                            </Link>
                        </div>
                    </div>
                ))}
               

                <div className="">
                    <div className="row blog-grid blog-right-col">
                    {sports.map((blogData, index)=>(
                        <>
                        {
                            index !== 0
                            ?
                            <div className="col-md-4 mb-5" key={blogData._id}>
                                {console.log(index)}
                                <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                                <p className="grid-Wallets">{blogData.category}</p>
                                <p className="grid-card-head">{blogData.title}</p>
                                <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                                <Link to={`/blog-detail/${blogData._id}`} className="grid-Read-Article">Read Article <img className="grid-arrow-img" alt="" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'}/></Link>
                            </div>
                        :
                        null
                        }
                        </>
                    ))}
                        
                       
                    </div>
                    
                </div>

            </div>

            <div className="container">
                {gaming.slice(0, 1).map(blogData=>(
                    <div className="row blog-section blog-right-col" key={blogData._id}>
                        <div className="col-md-6">
                            <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                        </div>
                        <div className="col-md-6">
                            <p className="blog-Wallets">{blogData.category}</p>
                            <p className="blogHeading">{blogData.title}</p>
                            <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                            <Link className="Read-Article" to={`/blog-detail/${blogData._id}`}>
                                <span>Read Article <img className="arrow-img" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'} alt=""/></span>
                            </Link>
                        </div>
                    </div>
                ))}
               

                <div className="">
                    <div className="row blog-grid blog-right-col">
                    {gaming.map((blogData, index)=>(
                        <>
                        {
                            index !== 0
                            ?
                            <div className="col-md-4 mb-5" key={blogData._id}>
                                {console.log(index)}
                                <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                                <p className="grid-Wallets">{blogData.category}</p>
                                <p className="grid-card-head">{blogData.title}</p>
                                <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                                <Link to={`/blog-detail/${blogData._id}`} className="grid-Read-Article">Read Article <img className="grid-arrow-img" alt="" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'}/></Link>
                            </div>
                        :
                        null
                        }
                        </>
                    ))}
                        
                       
                    </div>
                    
                </div>

            </div>

            <div className="container">
                {entertainment.slice(0, 1).map(blogData=>(
                    <div className="row blog-section blog-right-col" key={blogData._id}>
                        <div className="col-md-6">
                            <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                        </div>
                        <div className="col-md-6">
                            <p className="blog-Wallets">{blogData.category}</p>
                            <p className="blogHeading">{blogData.title}</p>
                            <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                            <Link className="Read-Article" to={`/blog-detail/${blogData._id}`}>
                                <span>Read Article <img className="arrow-img" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'} alt=""/></span>
                            </Link>
                        </div>
                    </div>
                ))}
               

                <div className="">
                    <div className="row blog-grid blog-right-col">
                    {entertainment.map((blogData, index)=>(
                        <>
                        {
                            index !== 0
                            ?
                            <div className="col-md-4 mb-5" key={blogData._id}>
                                {console.log(index)}
                                <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                                <p className="grid-Wallets">{blogData.category}</p>
                                <p className="grid-card-head">{blogData.title}</p>
                                <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                                <Link to={`/blog-detail/${blogData._id}`} className="grid-Read-Article">Read Article <img className="grid-arrow-img" alt="" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'}/></Link>
                            </div>
                        :
                        null
                        }
                        </>
                    ))}
                        
                       
                    </div>
                    
                </div>

            </div>

            <div className="container">
                {lifestyle.slice(0, 1).map(blogData=>(
                    <div className="row blog-section blog-right-col" key={blogData._id}>
                        <div className="col-md-6">
                            <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                        </div>
                        <div className="col-md-6">
                            <p className="blog-Wallets">{blogData.category}</p>
                            <p className="blogHeading">{blogData.title}</p>
                            <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                            <Link className="Read-Article" to={`/blog-detail/${blogData._id}`}>
                                <span>Read Article <img className="arrow-img" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'} alt=""/></span>
                            </Link>
                        </div>
                    </div>
                ))}
               

                <div className="">
                    <div className="row blog-grid blog-right-col">
                    {lifestyle.map((blogData, index)=>(
                        <>
                        {
                            index !== 0
                            ?
                            <div className="col-md-4 mb-5" key={blogData._id}>
                                {console.log(index)}
                                <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                                <p className="grid-Wallets">{blogData.category}</p>
                                <p className="grid-card-head">{blogData.title}</p>
                                <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                                <Link to={`/blog-detail/${blogData._id}`} className="grid-Read-Article">Read Article <img className="grid-arrow-img" alt="" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'}/></Link>
                            </div>
                        :
                        null
                        }
                        </>
                    ))}
                        
                       
                    </div>
                    
                </div>

            </div>

            <div className="container">
                {art.slice(0, 1).map(blogData=>(
                    <div className="row blog-section blog-right-col" key={blogData._id}>
                        <div className="col-md-6">
                            <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                        </div>
                        <div className="col-md-6">
                            <p className="blog-Wallets">{blogData.category}</p>
                            <p className="blogHeading">{blogData.title}</p>
                            <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                            <Link className="Read-Article" to={`/blog-detail/${blogData._id}`}>
                                <span>Read Article <img className="arrow-img" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'} alt=""/></span>
                            </Link>
                        </div>
                    </div>
                ))}
               

                <div className="">
                    <div className="row blog-grid blog-right-col">
                    {art.map((blogData, index)=>(
                        <>
                        {
                            index !== 0
                            ?
                            <div className="col-md-4 mb-5" key={blogData._id}>
                                {console.log(index)}
                                <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                                <p className="grid-Wallets">{blogData.category}</p>
                                <p className="grid-card-head">{blogData.title}</p>
                                <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                                <Link to={`/blog-detail/${blogData._id}`} className="grid-Read-Article">Read Article <img className="grid-arrow-img" alt="" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'}/></Link>
                            </div>
                        :
                        null
                        }
                        </>
                    ))}
                        
                       
                    </div>
                    
                </div>

            </div>

            <div className="container">
                {announcement.slice(0, 1).map(blogData=>(
                    <div className="row blog-section blog-right-col" key={blogData._id}>
                        <div className="col-md-6">
                            <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                        </div>
                        <div className="col-md-6">
                            <p className="blog-Wallets">{blogData.category}</p>
                            <p className="blogHeading">{blogData.title}</p>
                            <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                            <Link className="Read-Article" to={`/blog-detail/${blogData._id}`}>
                                <span>Read Article <img className="arrow-img" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'} alt=""/></span>
                            </Link>
                        </div>
                    </div>
                ))}
               

                <div className="">
                    <div className="row blog-grid blog-right-col">
                    {announcement.map((blogData, index)=>(
                        <>
                        {
                            index !== 0
                            ?
                            <div className="col-md-4 mb-5" key={blogData._id}>
                                {console.log(index)}
                                <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                                <p className="grid-Wallets">{blogData.category}</p>
                                <p className="grid-card-head">{blogData.title}</p>
                                <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                                <Link to={`/blog-detail/${blogData._id}`} className="grid-Read-Article">Read Article <img className="grid-arrow-img" alt="" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'}/></Link>
                            </div>
                        :
                        null
                        }
                        </>
                    ))}
                        
                       
                    </div>
                    
                </div>

            </div>

            <div className="container">
                {guestPost.slice(0, 1).map(blogData=>(
                    <div className="row blog-section blog-right-col" key={blogData._id}>
                        <div className="col-md-6">
                            <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                        </div>
                        <div className="col-md-6">
                            <p className="blog-Wallets">{blogData.category}</p>
                            <p className="blogHeading">{blogData.title}</p>
                            <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                            <Link className="Read-Article" to={`/blog-detail/${blogData._id}`}>
                                <span>Read Article <img className="arrow-img" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'} alt=""/></span>
                            </Link>
                        </div>
                    </div>
                ))}
               

                <div className="">
                    <div className="row blog-grid blog-right-col">
                    {guestPost.map((blogData, index)=>(
                        <>
                        {
                            index !== 0
                            ?
                            <div className="col-md-4 mb-5" key={blogData._id}>
                                {console.log(index)}
                                <img className="img-fluid thumbImgBlg" src={`https://appi.colexion.io/${blogData.img}`} alt="" />
                                <p className="grid-Wallets">{blogData.category}</p>
                                <p className="grid-card-head">{blogData.title}</p>
                                <p className="blogPara" dangerouslySetInnerHTML={{ __html: blogData.content }}></p>
                                <Link to={`/blog-detail/${blogData._id}`} className="grid-Read-Article">Read Article <img className="grid-arrow-img" alt="" src={process.env.PUBLIC_URL + '/images/blog/right-arrow.png'}/></Link>
                            </div>
                        :
                        null
                        }
                        </>
                    ))}
                        
                       
                    </div>
                    
                </div>

            </div>
                    










        </div>
    )
};

export default Blog;
